<template>
  <div>
    <b-form-group>
      <b-input-group class="mt-4">
        <template v-slot:prepend>
          <b-input-group-text>
            <strong class="text-danger">Ignore articles older then</strong>
          </b-input-group-text>
        </template>
        <b-form-input
          :disabled="searchPage"
          v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].ignoreArticlesOlderThen"
          type="number"
        ></b-form-input>
        <template v-slot:append>
          <b-input-group-text>
            <strong class="text-danger">Days</strong>
          </b-input-group-text>
        </template>
      </b-input-group>
    </b-form-group>
    <b-form-checkbox
      :disabled="searchPage"
      v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].ignoreArticlesWithoutDates"
    >Ignore articles without dates</b-form-checkbox>
    <b-form-checkbox
      :disabled="searchPage"
      v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].ignoreArticlesFromLocalSites"
    >Ignore articles from Local sites</b-form-checkbox>
    <b-form-checkbox
      :disabled="searchPage"
      v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].ignoreArticlesFromRegionalSites"
    >Ignore articles from Regional sites</b-form-checkbox>
    <b-form-checkbox
      :disabled="searchPage"
      v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].ignoreArticlesFromGlobalSites"
    >Ignore articles from Global sites</b-form-checkbox>
    <b-form-checkbox
      :disabled="searchPage"
      v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].ignoreArticlesFromGlobalRegionalLocalSites"
    >Ignore articles not in Global, Regional and Local</b-form-checkbox>
  </div>
</template>
<script>
export default {
  name: "FilteringComponent",
  data() {
    return {};
  },
  props: {
    negativeMediaEdit: Boolean,
    categoriesIndex: Number,
    negativeMediaTab: Boolean,
    searchPage: Boolean
  }
};
</script>